import React from 'react';
import { CirclePicker, SliderPicker, SketchPicker } from 'react-color';
import PropTypes from 'prop-types'

const DEFAULT_COLORS = ["#f44336", "#e91e63", "#9c27b0", "#673ab7", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#607d8b"]

class NRTColorPickerInput extends React.Component {

    focus() {
        this.setState({ color: '#22ff00' }, ()=>this.props.onChange('#22ff00') );
    }

    handleChange = ({hex}) =>  {
        this.setState({ color: hex }, ()=>this.props.onChange(hex) );
    }

    render() {

        const {pickertype} = this.props

        let ColorPickerComponent = null
        switch (pickertype) {
            case 'circle':
                ColorPickerComponent = CirclePicker
                break
            case 'slider':
                ColorPickerComponent = SliderPicker
                break
            default:
                ColorPickerComponent = SketchPicker
        }

        return <CirclePicker
            colors={this.props.colors || DEFAULT_COLORS }
            color={ this.props.value }
            onChange={ this.handleChange }
        />
    }
}

NRTColorPickerInput.defaultProps = {
    pickertype: 'circle',
}

NRTColorPickerInput.propTypes = {
    pickertype: PropTypes.string,
}

export default NRTColorPickerInput


// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/ColorPickerInput/index.js